<template>
    <div>
        <div v-if="triggerDescription">
            {{ triggerDescription }}
        </div>
        <div
            v-for="(action, i) in actions"
            v-bind:key="`${listKey}-${i}`"
            v-bind:class="listClass">
            <span class="fw-bold">{{ action.ActionMessage }}</span>
            <span> - Condition: [</span>
            <span>{{ action.ConditionDisplayName }}</span>
            <span>]</span>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            // Unique key for this list of potential follow-up actions in case we're displaying
            // multiple lists of actions related to different triggers, for instance as we do
            // before a status change
            listKey: { type: String, required: true },
            actions: { type: Array, required: false, default: () => [] },
            triggerDescription: { type: String, required: false, default: null }
        },
        computed: {
            indentList() {
                return Boolean(this.triggerDescription);
            },
            listClass() {
                return this.indentList ? "ms-4" : "";
            }
        }
    };
</script>
